import React from 'react';
import {useField} from 'formik';
import classNames from 'classnames';

import {LETTER_GRADE_OPTIONS, OTHER_GRADE_OPTIONS} from 'shared/utils';
import {finalGradingPeriodMap} from 'shared/portfolio/utils';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

import Label from 'shared/components/label';
import FormikDropdown from 'src/components/formik-dropdown';
import {CourseForm} from './course-form-wrapper';

import styles from './grade-dropdowns.module.scss';
import {ButtonSizes} from 'shared/constants';

const otherGradeOptions = Object.keys(OTHER_GRADE_OPTIONS).map((grade) => ({
  value: OTHER_GRADE_OPTIONS[grade],
  text: grade,
  group: 'Other Grades',
}));

const numericGradeOptions = Array.from({length: 101}, (_, i) => 100 - i)
  .map((i) => ({
    value: i.toString(),
    text: i.toString(),
    group: 'Numeric Grades',
  }))
  .concat(otherGradeOptions);

interface Props {
  className?: string;
  hideGradeLabel?: boolean;
  size?: ButtonSizes;
  prefix?: string;
}

const GradeDropdowns = ({className, hideGradeLabel, size = 'medium', prefix = ''}: Props) => {
  const mq = useMediaQuery();
  const [field] = useField<CourseForm['grades']>(`${prefix}grades`);

  return field.value.map((grade, i) => (
    <Label key={grade._id} className={className}>
      {finalGradingPeriodMap[grade.period] ||
        `${grade.period} ${mq.MS_AND_UP && !hideGradeLabel ? 'Grade' : ''}`}

      <FormikDropdown
        name={`${prefix}grades.${i}.gradeInput`}
        placeholder=" "
        size={size}
        className={classNames({[styles.dropdown]: size === 'small'})}
        options={grade.gradeType === 'L' ? LETTER_GRADE_OPTIONS : numericGradeOptions}
        testid={`bulk-entry-grade-input${i}`}
      />
    </Label>
  ));
};

export default GradeDropdowns;
